export const container = { width: "100%", overflow: "auto" }

export const searchCont = {
  width: "max-content",
  minWidth: "350px",
  padding: "20px 0",
  margin: "0 20px",
}

export const cardsCont = {
  padding: "0 20px",
  display: "flex",
  flexWrap: "wrap",
  gap: "20px",
  marginBottom: "20px",
}
